import { NextErrorsPanel } from 'components/shared/ErrorsPanel/NextErrorsPanel';
import { PriceNext, QuoteStatus } from 'components/shared/PriceNext';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { ErrorState } from './Error.connect';
import { connectError } from './Error.connect';

export const Component: FC<ErrorState> = ({ message, values }) => {
  const { formatMessage } = useIntl();
  const msg = formatMessage({ id: message as IntlKey, defaultMessage: message }, values);

  return (
    <PriceNext
      className="bg-danger text-danger bg-opacity-10"
      errorTop={
        <NextErrorsPanel
          className="text-danger"
          layout="summaryOnly"
          shouldUseRejectionCode={false}
          workflowErrors={[{ originMessage: msg }]}
        />
      }
      quoteStatus={
        <QuoteStatus className="alert alert-danger" icon="block" description="sidePanel.quoteStatus.error" />
      }
    />
  );
};

export const ErrorComponent = connectError(Component);

Component.displayName = 'SidePanelErrors';
